"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyCulture = getLegacyCulture;
/**
 * Transforms {@link culture} and {@link financialSet financial settings} to an object containing formatting rules that can be used by the legacy formatters, e.g. @ori/formatter.
 * @param language Selected language
 * @param culture Culture settings containing rules for formatting percentages, currency, etc.
 * @param financialSet Financial settings containing currency specification
 * @returns An object containing formatting rules for legacy formatters, e.g. \@ori/formatter
 * @deprecated Use \@ori/culture package features to format instead of legacy formatters.
 */
function getLegacyCulture(language, culture, financialSet) {
  return {
    name: language,
    numberFormat: {
      oriCurrency: {
        // format: "", // this might be needed in the future
        decimals: culture?.currencyFormat?.decimals,
        '.': culture?.currencyFormat?.decimalSeparator,
        ',': culture?.currencyFormat?.groupSeparator,
        groupSize: culture?.currencyFormat?.groupSizes,
        pattern: [culture?.currencyFormat?.negativePattern, culture?.currencyFormat?.positivePattern],
        symbol: financialSet?.currencySymbol
      },
      percent: {
        decimals: culture?.percentFormat?.decimals,
        '.': culture?.percentFormat?.decimalSeparator,
        ',': culture?.percentFormat?.groupSeparator,
        groupSize: culture?.percentFormat?.groupSizes,
        pattern: [culture?.percentFormat?.negativePattern, culture?.percentFormat?.positivePattern],
        symbol: culture?.percentFormat?.symbol
      }
    }
  };
}
//# sourceMappingURL=getLegacyCulture.js.map